<template>
  <div>
    <!-- authenticated paths -->
    <TheLayout v-if="$user">
      <router-view />
    </TheLayout>

    <!-- auth paths -->
    <TheLayoutAuth v-else>
      <router-view />
    </TheLayoutAuth>
    <notifications group="error" :duration="5000" />
  </div>
</template>

<script>
import TheLayout from '@/components/TheLayout';
import TheLayoutAuth from '@/components/TheLayoutAuth';

import { hasAdminAccess } from '@/utils';

// no need to apply these actions to ricoma employees wihth access to users's portal
const initGlobalCustomerData = (user, store, i18n) => {
  if (user && !hasAdminAccess(user)) {
    i18n.locale = user.lang_code ?? 'en';
    initGlobalLanguage(user, store);
    store.dispatch('customer/getNotifications');
  }
};

const initGlobalLanguage = async (user, store) => {
  const languages = await store.dispatch('getLanguages');
  const language = languages.find(l => l.code === user.lang_code);
  if (language) store.commit(`setLanguage`, language);
};

export default {
  name: 'App',
  components: { TheLayout, TheLayoutAuth },
  watch: {
    $user(user) {
      initGlobalCustomerData(user, this.$store, this.$i18n);
    },
  },
  mounted() {
    this.$nextTick(function () {
      initGlobalCustomerData(this.$user, this.$store, this.$i18n);
    });
  },
};
</script>
